export const hasRole = (role) => ({ currentUser }) => {
  if(!Array.isArray(role)) {
    role = [role];
  }

  return role.includes(currentUser?.systemRole);
}
